import { render, staticRenderFns } from "./GuppyChatSidebar.vue?vue&type=template&id=4950cd66&scoped=true&"
import script from "./GuppyChatSidebar.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSidebar.vue?vue&type=style&index=0&id=4950cd66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4950cd66",
  null
  
)

export default component.exports